module.exports = __webpack_public_path__ + "media/images/communities/logos/wjc-israel-4b043be837fb7990bfcbac6c5e9a2440.png";